import get from "lodash.get";

export function getNameMaterial(fullName = "") {
  return fullName.split(/ in (.+)/);
}

export function mapTagTitleToProductTags(tags = [], productTags = []) {
  return tags.map((tag) => ({
    ...tag,
    title: get(
      productTags.find(({ id }) => id === tag.tagId),
      "title",
      ""
    ),
  }));
}

export function getProductHighLightedTag(product, tags = []) {
  const productTagsWithTitle = mapTagTitleToProductTags(product.tags, tags);
  const highLightedTag = productTagsWithTitle.find(({ title }) =>
    title.startsWith("HIGHLIGHTED")
  )?.title;
  if (product.id === 6614) {
    console.log("productTagsWithTitle", productTagsWithTitle, highLightedTag);
  }
  return highLightedTag;
}

export const sortByProductsOrder = (productsOrder) => {
  return (a, b) => {
    const aIndex = productsOrder.findIndex((id) => id === a?.id);
    const bIndex = productsOrder.findIndex((id) => id === b?.id);
    return aIndex - bIndex;
  };
};
